import { render, staticRenderFns } from "./classes-questionPartner.vue?vue&type=template&id=6117b950&scoped=true"
import script from "./classes-questionPartner.vue?vue&type=script&lang=js"
export * from "./classes-questionPartner.vue?vue&type=script&lang=js"
import style0 from "./classes-questionPartner.vue?vue&type=style&index=0&id=6117b950&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6117b950",
  null
  
)

export default component.exports